import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X, Copy } from "lucide-react";

export function ImageViewerModal({
  open,
  onOpenChange,
  image,
  product,
  zoomLevel,
  onZoomChange,
  onCopyImage,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl p-0 overflow-hidden bg-white" data-testid="image-viewer-modal">
        <div className="relative">
          <button
            onClick={() => onOpenChange(false)}
            className="absolute top-4 right-4 z-10 p-2 rounded-full bg-black/50 hover:bg-black/70 text-white transition-colors"
            data-testid="close-viewer-btn"
          >
            <X className="w-5 h-5" />
          </button>

          <div
            className="relative overflow-hidden bg-slate-100 flex items-center justify-center min-h-[500px] cursor-zoom-in"
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = ((e.clientX - rect.left) / rect.width) * 100;
              const y = ((e.clientY - rect.top) / rect.height) * 100;
              e.currentTarget.style.setProperty('--zoom-x', `${x}%`);
              e.currentTarget.style.setProperty('--zoom-y', `${y}%`);
            }}
            onMouseEnter={() => onZoomChange(2)}
            onMouseLeave={() => onZoomChange(1)}
            onContextMenu={(e) => e.stopPropagation()}
            style={{ '--zoom-x': '50%', '--zoom-y': '50%' }}
          >
            {image && (
              <img
                src={image}
                alt={product?.product_name || "Produto"}
                className="max-w-full max-h-[500px] object-contain transition-transform duration-200"
                style={{ transform: `scale(${zoomLevel})`, transformOrigin: 'var(--zoom-x) var(--zoom-y)' }}
                data-testid="viewer-image"
              />
            )}
          </div>

          {product && (
            <div className="p-6 border-t border-slate-200">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-semibold text-slate-900">{product.product_name || "Produto"}</h3>
                  <p className="text-sm text-slate-500">EAN: {product.ean} {product.brand && `• ${product.brand}`}</p>
                </div>
                <div className="flex gap-2">
                  <Button onClick={() => onCopyImage(image)} variant="outline" className="border-slate-200" data-testid="viewer-copy-btn">
                    <Copy className="w-4 h-4 mr-2" />
                    Copiar
                  </Button>
                </div>
              </div>
              <p className="text-xs text-slate-400 mt-2">Dica: Clique com botão direito na imagem → "Copiar imagem"</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
